module.exports = __webpack_public_path__ + "img/cb4-2-r-rg1.62dda67b.gif";